import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {FlowMode} from "../dto/enum/flow.mode.enum";

@Injectable({ providedIn: 'root' })
export class FlowModeSubject {
    private mode$ = new BehaviorSubject<FlowMode | null>(null);

    setMode(mode: FlowMode): void {
        this.mode$.next(mode);
    }

    getMode$(): Observable<FlowMode | null> {
        return this.mode$.asObservable();
    }

    getCurrentMode(): FlowMode | null {
        return this.mode$.getValue();
    }

    clearMode(): void {
        this.mode$.next(null);
    }

    isInitialized(): boolean {
        return this.mode$.getValue() !== null;
    }
}
